/// <amd-module name="TFS/Admin/Common/RestClient/PermissionLevel" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   vssf\client\webapi\httpclients\clientgeneratorconfigs\permissionlevel.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as PermissionLevel from "../Contracts/PermissionLevel";

export interface IPermissionLevelRestClient extends IVssRestClient {
    /**
     * @param subjectDescriptor - 
     * @param definitionId - 
     * @param resourceId - 
     */
    assignPermissionLevel(subjectDescriptor: string, definitionId: string, resourceId: string): Promise<PermissionLevel.PermissionLevelAssignment>;
    /**
     * @param resourceId - 
     * @param definitionId - 
     * @param pageSize - 
     * @param continuationToken - 
     */
    getPermissionLevelAssignmentsByDefinitionId(resourceId: string, definitionId: string, pageSize?: number, continuationToken?: string): Promise<PermissionLevel.PagedPermissionLevelAssignment>;
    /**
     * @param resourceId - 
     * @param scope - 
     * @param pageSize - 
     * @param continuationToken - 
     */
    getPermissionLevelAssignmentsByScope(resourceId: string, scope: PermissionLevel.PermissionLevelDefinitionScope, pageSize?: number, continuationToken?: string): Promise<PermissionLevel.PagedPermissionLevelAssignment>;
    /**
     * @param subjectDescriptor - 
     * @param resourceId - 
     * @param scope - 
     */
    getPermissionLevelAssignmentsByScopeAndSubject(subjectDescriptor: string, resourceId: string, scope: PermissionLevel.PermissionLevelDefinitionScope): Promise<PermissionLevel.PermissionLevelAssignment[]>;
    /**
     * @param subjectDescriptor - 
     * @param definitionId - 
     * @param resourceId - 
     */
    removePermissionLevelAssignment(subjectDescriptor: string, definitionId: string, resourceId: string): Promise<void>;
    /**
     * @param subjectDescriptor - 
     * @param resourceId - 
     * @param definitionId - 
     * @param newDefinitionId - 
     */
    updatePermissionLevelAssignment(subjectDescriptor: string, resourceId: string, definitionId: string, newDefinitionId: string): Promise<PermissionLevel.PermissionLevelAssignment>;
    /**
     * @param definitionIds - 
     */
    getPermissionLevelDefinitionsById(definitionIds?: string[]): Promise<{ [key: string] : PermissionLevel.PermissionLevelDefinition; }>;
    /**
     * @param definitionScope - 
     * @param definitionType - 
     */
    getPermissionLevelDefinitionsByScope(definitionScope: PermissionLevel.PermissionLevelDefinitionScope, definitionType: PermissionLevel.PermissionLevelDefinitionType): Promise<PermissionLevel.PermissionLevelDefinition[]>;
}

class PermissionLevelRestClient extends RestClientBase implements IPermissionLevelRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param subjectDescriptor - 
     * @param definitionId - 
     * @param resourceId - 
     */
    public async assignPermissionLevel(
        subjectDescriptor: string,
        definitionId: string,
        resourceId: string
        ): Promise<PermissionLevel.PermissionLevelAssignment> {

        const queryValues: any = {
            definitionId: definitionId,
            resourceId: resourceId
        };

        return this.beginRequest<PermissionLevel.PermissionLevelAssignment>({
            apiVersion: "5.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/PermissionLevel/PermissionLevelAssignments/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * @param resourceId - 
     * @param definitionId - 
     * @param pageSize - 
     * @param continuationToken - 
     */
    public async getPermissionLevelAssignmentsByDefinitionId(
        resourceId: string,
        definitionId: string,
        pageSize?: number,
        continuationToken?: string
        ): Promise<PermissionLevel.PagedPermissionLevelAssignment> {

        const queryValues: any = {
            resourceId: resourceId,
            definitionId: definitionId,
            pageSize: pageSize,
            continuationToken: continuationToken
        };

        return this.beginRequest<PermissionLevel.PagedPermissionLevelAssignment>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "_apis/PermissionLevel/PermissionLevelAssignments/{subjectDescriptor}",
            queryParams: queryValues
        });
    }

    /**
     * @param resourceId - 
     * @param scope - 
     * @param pageSize - 
     * @param continuationToken - 
     */
    public async getPermissionLevelAssignmentsByScope(
        resourceId: string,
        scope: PermissionLevel.PermissionLevelDefinitionScope,
        pageSize?: number,
        continuationToken?: string
        ): Promise<PermissionLevel.PagedPermissionLevelAssignment> {

        const queryValues: any = {
            resourceId: resourceId,
            scope: scope,
            pageSize: pageSize,
            continuationToken: continuationToken
        };

        return this.beginRequest<PermissionLevel.PagedPermissionLevelAssignment>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "_apis/PermissionLevel/PermissionLevelAssignments/{subjectDescriptor}",
            queryParams: queryValues
        });
    }

    /**
     * @param subjectDescriptor - 
     * @param resourceId - 
     * @param scope - 
     */
    public async getPermissionLevelAssignmentsByScopeAndSubject(
        subjectDescriptor: string,
        resourceId: string,
        scope: PermissionLevel.PermissionLevelDefinitionScope
        ): Promise<PermissionLevel.PermissionLevelAssignment[]> {

        const queryValues: any = {
            resourceId: resourceId,
            scope: scope
        };

        return this.beginRequest<PermissionLevel.PermissionLevelAssignment[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "_apis/PermissionLevel/PermissionLevelAssignments/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * @param subjectDescriptor - 
     * @param definitionId - 
     * @param resourceId - 
     */
    public async removePermissionLevelAssignment(
        subjectDescriptor: string,
        definitionId: string,
        resourceId: string
        ): Promise<void> {

        const queryValues: any = {
            definitionId: definitionId,
            resourceId: resourceId
        };

        return this.beginRequest<void>({
            apiVersion: "5.1-preview.1",
            method: "DELETE",
            routeTemplate: "_apis/PermissionLevel/PermissionLevelAssignments/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * @param subjectDescriptor - 
     * @param resourceId - 
     * @param definitionId - 
     * @param newDefinitionId - 
     */
    public async updatePermissionLevelAssignment(
        subjectDescriptor: string,
        resourceId: string,
        definitionId: string,
        newDefinitionId: string
        ): Promise<PermissionLevel.PermissionLevelAssignment> {

        const queryValues: any = {
            resourceId: resourceId,
            definitionId: definitionId,
            newDefinitionId: newDefinitionId
        };

        return this.beginRequest<PermissionLevel.PermissionLevelAssignment>({
            apiVersion: "5.1-preview.1",
            method: "PUT",
            routeTemplate: "_apis/PermissionLevel/PermissionLevelAssignments/{subjectDescriptor}",
            routeValues: {
                subjectDescriptor: subjectDescriptor
            },
            queryParams: queryValues
        });
    }

    /**
     * @param definitionIds - 
     */
    public async getPermissionLevelDefinitionsById(
        definitionIds?: string[]
        ): Promise<{ [key: string] : PermissionLevel.PermissionLevelDefinition; }> {

        const queryValues: any = {
            definitionIds: definitionIds && definitionIds.join(",")
        };

        return this.beginRequest<{ [key: string] : PermissionLevel.PermissionLevelDefinition; }>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "_apis/PermissionLevel/PermissionLevelDefinitions",
            queryParams: queryValues
        });
    }

    /**
     * @param definitionScope - 
     * @param definitionType - 
     */
    public async getPermissionLevelDefinitionsByScope(
        definitionScope: PermissionLevel.PermissionLevelDefinitionScope,
        definitionType: PermissionLevel.PermissionLevelDefinitionType
        ): Promise<PermissionLevel.PermissionLevelDefinition[]> {

        const queryValues: any = {
            definitionScope: definitionScope,
            definitionType: definitionType
        };

        return this.beginRequest<PermissionLevel.PermissionLevelDefinition[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "_apis/PermissionLevel/PermissionLevelDefinitions",
            queryParams: queryValues
        });
    }

}

export const PermissionLevelClientName = "IPermissionLevelRestClient";

export function getPermissionLevelClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPermissionLevelRestClient {
    return pageContext.getRestClient<IPermissionLevelRestClient>(PermissionLevelClientName, options);
}

RestClients.add(PermissionLevelClientName, { 
    factory: PermissionLevelRestClient,
    options: {
        serviceInstanceType: "951917ac-a960-4999-8464-e3f0aa25b381"
    }
});
